
export default {


    'samples': true,
    'production': '',
    // 'production': '/officeride'

    // Feature flag for the JWT-expiry auto-logout mechanism.
    // Default: enabled. Only an explicit `false` disables it.
    'autoLogout': false,
}
